interface ParamWithId {
  id: string | number;
  children?: unknown;
  isChild?: boolean;
}

export const findParamById = <T extends ParamWithId>(
  params: T[],
  targetId: unknown
): T[] => {
  if (!params?.length) return [];

  return params.reduce<T[]>((foundResult, param) => {
    if (foundResult.length) return foundResult;

    if (String(param.id) === String(targetId)) {
      return [param];
    }

    const foundChild = (param.children || []).find(
      child => String(child.id) === String(targetId)
    );

    if (foundChild) return [param, { ...foundChild, isChild: true }];

    return foundResult;
  }, []);
};
